import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GoalSettingsState } from 'types';

export const initialState: GoalSettingsState = {
  loading: false,
  goalSettingsList: [],
  reset: false,
  territories: []
};

const slice = createSlice({
  name: 'GoalSettings',
  initialState,
  reducers: {
    setGoalSettingsList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.goalSettingsList = payload || [];
      state.reset = false;
    },
    reset: (state) => {
      state.reset = true;
    },
    setTerritories: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.territories = payload || [];
    }
  }
});

export const { setGoalSettingsList, reset, setTerritories } = slice.actions;

export default slice.reducer;
